import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { UtilityService } from '../../services/utility.service'
import * as moment from 'moment';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { LearnerService } from 'src/app/services/learner.service';
import { DownloadService } from '../../services/download.service'
import { Subject } from 'rxjs';

@Component({
  selector: 'app-group-profile-form',
  templateUrl: './group-profile-form.component.html',
  styleUrls: ['./group-profile-form.component.scss']
})
export class GroupProfileFormComponent implements OnInit {

  @Input('isIQA') Iqa
  @Input('document') documentData;
  @Input('jobDetails') jobData;
  @Input('learnerArray') learnerArray;
  @Output() gpFormData: EventEmitter<any> = new EventEmitter<any>();
  gpForm
  visitorForm
  docData
  selectedInstructor = [];
  selectedLocation = [];
  instructors = []
  singleJob
  learners = []
  temp: [];
  instructor: FormArray;
  learner: FormArray;
  allInst = []
  courseDescription
  locations = []
  visitorsArray = []
  user
  descDate
  descInput1
  descInput2
  descInput3
  descInput4
  loading = false
  dateForVisitor
  arrayOfVisitor = []
  visitors = []
  visitorGlobal: any[];
  startDate
  endDate
  getLearners: any = [];
  selectedLearner: any = [];
  isIQA: boolean = false;
  isClient: boolean = false;
  private learnerRemove: Subject<any> = new Subject<any>();
  private addLearnerSubscription: Subject<any> = new Subject<any>();
  constructor(
    public _utilityService: UtilityService,
    public _cd: ChangeDetectorRef,
    public formBuilder: FormBuilder,
    private _learnerService: LearnerService,
    private _downloadService: DownloadService

  ) {

    // this.learners = [];
    // // this.dataSource = new MatTableDataSource(this.learners);
    this._learnerService.newLearnerObservable()
      .pipe(
        takeUntil(this.addLearnerSubscription)
      )
      .subscribe((newLearner) => {
        console.log("who is new learner", newLearner);
        this.learners.push(newLearner.learner)

        // this.learnerList.push(newLearner.learner)
        // this._change.detectChanges();
      });

    // this._learnerService.removeLearnerObservable()
    //   .pipe(
    //     takeUntil(this.learnerRemove)
    //   )
    //   .subscribe((learner) => {
    //     console.log("when learner remove from job", learner);
    //     console.log("isLearnerRemove subscribe==>", (!this.learnerRemove.closed))
    //     let index = this.learners.findIndex(x => x._id === learner._id);
    //     if (index > -1) {
    //       this.learners.splice(index, 1)
    //       // this.learnerList.splice(index,1)
    //       console.log("after learner remove in assignment page", this.learner);

    //       // this.updateData(this.learners)
    //     }
    //   })






    // this._learnerService.newLearnerObservable().subscribe((newLearner) => {
    //   console.log("who is new learner", newLearner, this.learners);
    //   this.learners.push(newLearner.learner)
    // });
    // this._learnerService.removeLearnerObservable().subscribe((removeLearner) => {
    //   console.log("learner details  ", this.learners, removeLearner);
    //   if (this.learners && this.learners.length) {
    //     this.learners.splice(this.learners.findIndex(function (i) {
    //       return i._id === removeLearner._id;
    //     }), 1);
    //   }
    // });
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.createForm()
    this.visitor()
    console.log("login user role========== in documents", this.user);
    console.log("this.learners=== ", this.learners);
  }


  ngOnDestroy() {
    this.learnerRemove.next();
    this.learnerRemove.complete();
    this.addLearnerSubscription.next();
    this.addLearnerSubscription.complete();

    console.log("this.learnerRemove!!!", (!this.learnerRemove.closed))
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of single doc", changes);
    if (changes.Iqa && changes.Iqa.currentValue) {
      console.log("changes...", changes.Iqa);
      this.isIQA = changes.Iqa.currentValue;
    }
    if (changes.documentData && changes.documentData.currentValue != undefined) {
      this.docData = changes.documentData.currentValue
      this.courseDescription = this.docData.details.description
      this.gpForm.controls.startDate.setValue(this._utilityService.returnCommonDateFormate(this.docData.details.startDate))
      this.gpForm.controls.endDate.setValue(this._utilityService.returnCommonDateFormate(this.docData.details.endDate));
      this.descDate = ((this.docData.details && this.docData.details.descDate != null) ? new Date(this.docData.details.descDate) : '')
      this.descInput1 = this.docData.details.descInput1
      this.descInput2 = this.docData.details.descInput2
      this.descInput3 = this.docData.details.descInput3
      this.descInput4 = this.docData.details.descInput4

      if (this.docData.details && (this.docData.details.visitors && this.docData.details.visitors.length)) {
        this.visitorsArray = this.docData.details.visitors
        this.visitor()
      }
    }
    if (changes.learnerArray && changes.learnerArray.currentValue) {
      this.learners = changes.learnerArray.currentValue
      console.log("this.learners------>", this.learners);
    }
    if (changes.jobData && changes.jobData.currentValue != undefined) {
      this.singleJob = changes.jobData.currentValue
      console.log("this.singleJob------>", this.singleJob);
      this.getInst()
    }


  }


  onChangeEvent(value, formGroup, formControl) {
    console.log(formControl, formGroup);
    if (formGroup == 'gpForm')
      this.gpForm.get(formControl).setValue(value);
  }

  onChange(value, i) {

    console.log("here ios the visitor !!!==>", this.visitorGlobal)

    if (this.visitorGlobal && this.visitorGlobal.length) {
      let obj = this.visitorGlobal[i];

      console.log("here is Obj value///", obj);

      if (obj != undefined) {
        obj['visitorDate'] = value
        console.log("this for global define !!!!", obj)
        let controlArray = <FormArray>this.visitorForm.controls["visitors"];
        controlArray.controls[i].patchValue(obj);
        console.log("here is the controlv value .....", controlArray)
      }
      else {
        let controlArray = <FormArray>this.visitorForm.controls["visitors"];
        controlArray.controls[i].patchValue({ visitorDate: value });
      }
    }
    else {
      let controlArray = <FormArray>this.visitorForm.controls["visitors"];
      controlArray.controls[i].patchValue({ visitorDate: value });
    }


  }


  editvisitordate(value) {
    return value.value.visitorDate
  }

  createForm() {
    this.gpForm = new FormGroup({
      // course: new FormControl(''),
      learner: new FormControl(''),
      instructor: new FormControl(''),
      locations: new FormControl(''),
      startDate: new FormControl(moment()),
      endDate: new FormControl(moment())
    })


    if (this.user && this.user.isClient) {
      console.log("call this or not", this.user);
      this.isClient = true
      // this.gpForm.controls['course'].disable();
      // this.gpForm.controls['instructor'].disable();
      // this.gpForm.controls['locations'].disable();
      // this.gpForm.controls['startDate'].disable();
      // this.gpForm.controls['endDate'].disable();
    }

  }

  visitor() {
    this.visitorForm = new FormGroup({
      visitors: this.formBuilder.array(this.multipleVisitors(this.visitorsArray))
    })

    if (this.isClient || this.isIQA) {
      this.visitorForm.controls['visitors'].disable();
    }

  }
  get multipleVisitorsGroup() { return <FormArray>this.visitorForm.get('visitors') }


  multipleVisitors(visitors): Array<any> {
    if (visitors && visitors.length) {

      console.log("here visitor value check here ==>", visitors)


      this.visitorGlobal = visitors
      const visitor = []
      _.forEach(visitors, async (visit) => {
        this.dateForVisitor = visit.visitorDate
        await visitor.push(new FormGroup({
          visitorName: new FormControl(visit.visitorName),
          visitorDate: new FormControl(visit.visitorDate),
        }))
      })
      return visitor;
    } else {
      return [this.formBuilder.group({
        visitorName: new FormControl(''),
        visitorDate: new FormControl(''),
      })
      ]
    }
  }



  addVisitors() {
    const control = <FormArray>this.visitorForm.controls.visitors

    control.push(this.formBuilder.group({
      visitorName: new FormControl(''),
      visitorDate: new FormControl(''),
    }))
  }



  deleteVisitor(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.visitorForm.controls.visitors
    control.removeAt(i)
  }


  onChangeVarible(value) {
    this.descDate = value
    console.log("here is the this desc date ////", this.descDate)
  }




  // Display Data 
  // getLearner() {
  //   console.log("how much time it is call");
  //   console.log("this.learners in getLeaner() ------>", this.learners);
  //   if (this.learners && this.learners.length) {
  //     this.learners.forEach((singleLearner) => {
  //       let obj = {
  //         _id: singleLearner._id,
  //         name: singleLearner.name
  //       }
  //       let index = this.learners.findIndex((o) => o._id == singleLearner._id)
  //       if (index == -1) {
  //         this.learners.push(obj)
  //       }
  //     })

  //     this.selectedLearner = (this.docData && this.docData.details) ? this.docData.details.learners : ['']
  //     console.log("this.selectedLearner", this.selectedLearner)
  //     this.gpForm.controls.learner.setValue(this.selectedLearner);
  //     this._cd.detectChanges()
  //   } else {
  //     this.learners = []
  //   }

  // }

  getInst() {
    console.log("how much time it is call");

    // For Get Learner
    console.log("this.learners in getLeaner() ------>", this.learners);
    if (this.learners && this.learners.length) {
      this.learners.forEach((singleLearner) => {
        let obj = {
          _id: singleLearner._id,
          name: singleLearner.name
        }
        let index = this.learners.findIndex((o) => o._id == singleLearner._id)
        if (index == -1) {
          this.learners.push(obj)
        }
      })

      this.selectedLearner = (this.docData && this.docData.details) ? this.docData.details.learners : ['']
      console.log("this.selectedLearner", this.selectedLearner)
      this.gpForm.controls.learner.setValue(this.selectedLearner);
      this._cd.detectChanges()
    } else {
      this.learners = []
    }

    // For Get Instructor
    if (this.singleJob.instructors && this.singleJob.instructors.length) {
      let tempArray = []
      console.log("this.singleJob.instructors", this.singleJob.instructors)
      this.singleJob.instructors.forEach((singleIns) => {
        let obj = {
          _id: singleIns._id,
          name: singleIns.name
        }
        if (singleIns.role == 'trainer') this.selectedInstructor.push(singleIns._id)
        console.log("this is push or not", this.selectedInstructor);

        let index = this.instructors.findIndex((o) => o._id == singleIns._id)
        if (index == -1) {
          this.instructors.push(obj)
        }
      })


      this.selectedInstructor = (this.docData && this.docData.details) ? this.docData.details.instructors : this.selectedInstructor
      console.log("this.selectedInstructor", this.selectedInstructor)
      this.gpForm.controls.instructor.setValue(this.selectedInstructor);
      this._cd.detectChanges()

    } else {
      this.instructors = []
    }


    // For Get Location
    if (this.singleJob.clients && this.singleJob.clients.length) {
      this.singleJob.clients.forEach((location) => {
        this.locations.push(location.location)
      })

      this.selectedLocation = (this.docData && this.docData.details) ? this.docData.details.locations : ['']
      // console.log("this.selectedInstructor", this.selectedLocation)
      this.gpForm.controls.locations.setValue(this.selectedLocation);
      this._cd.detectChanges()

    }

    // For Get Dates

    if ((this.docData && this.docData.details) && !this.docData.details.startDate && !this.docData.details.endDate) {
      if (this.singleJob && this.singleJob.singleJobDate && this.singleJob.singleJobDate.length) {
        this.startDate = this.singleJob.startingDate
        console.log("what is start date", this.startDate);
        this.gpForm.controls.startDate.setValue(this.startDate);
        this.endDate = this.singleJob.singleJobDate.slice(-1)[0].date
        this.gpForm.controls.endDate.setValue(this.endDate);
        this._cd.detectChanges()
      } else {
        this.startDate = this.singleJob.startingDate
        this.endDate = this.singleJob.endingDate
        this.gpForm.controls.startDate.setValue(this.singleJob.startingDate);
        this.gpForm.controls.endDate.setValue(this.singleJob.endingDate);
        this._cd.detectChanges()
      }
    }
    // console.log("what is the form value after get data", this.gpForm.value);
    // this.createForm()
  }

  compareObjects(o1: any, o2: any): boolean {
    console.log("compareObjects called")
    return o1 && o1.name === o2 && o2.name && o1.id === o2.id;
  }

  compareStaff(o1: any, o2: any): boolean {
    console.log("compareObjects called", o1, o2)
    return o1._id === o2._id;
  }

  compareLocation(o1: any, o2: any): boolean {
    return o1.title === o2.title && o1.id === o2.id;
  }

  // Change Event

  submitForm() {
    this.loading = true
    // console.log("first form value", this.gpForm.value);z
    // console.log("description value======", this.courseDescription);
    // console.log("final form with visitors data", this.visitorForm.value);
    let finalObj = {
      jobId: this.singleJob._id,
      onModel: 'job',
      details: {
        _id: this.docData.details._id,
        // course: this.gpForm.controls['course'].value,
        learners: this.gpForm.controls['learner'].value,
        instructors: this.gpForm.controls['instructor'].value,
        locations: this.gpForm.controls['locations'].value,
        startDate: this.gpForm.controls['startDate'].value,
        endDate: this.gpForm.controls['endDate'].value,
        description: this.courseDescription,
        visitors: this.visitorForm.controls['visitors'].value,
        descDate: this.descDate,
        descInput1: this.descInput1,
        descInput2: this.descInput2,
        descInput3: this.descInput3,
        descInput4: this.descInput4,

      },
      documentMetaId: this.docData.documentMetaId,
      documentId: this.docData._id
    }
    console.log("what is the final main object for update", finalObj);

    this.gpFormData.emit(finalObj)
    this.loading = false
  }

  download() {
    this.loading = true
    console.log('documentData', this.documentData)
    let obj = {
      csvType: 'groupProfile',
      documentData: this.documentData,
      descInput1: this.descInput1,
      descInput2: this.descInput3,
      descInput3: this.descInput4,
      descDate: this.descDate,
      currentJob: this.singleJob,
      startDate: this.startDate,
      endDate: this.endDate

    }
    this._downloadService.downloadCSV(obj).subscribe((csvResponse) => {
      this.loading = false
      const downloadLink = document.createElement("a");

      if (csvResponse && csvResponse.data) {
        this._utilityService.handleSnackBar({ msg: "CSV download Successfully!", button: "Ok" })
        downloadLink.href = csvResponse.data;
        downloadLink.click();

      }
    }, (error) => {
      this.loading = false
      this._utilityService.handleSnackBar({ msg: "CSV download Fail!", button: "Ok" })
      console.log("SOME error occure ===>", error)
    })
  }




}
